import { render } from "./GenericTable.vue?vue&type=template&id=c49bb168&scoped=true"
import script from "./GenericTable.vue?vue&type=script&lang=js"
export * from "./GenericTable.vue?vue&type=script&lang=js"

import "./GenericTable.vue?vue&type=style&index=0&id=c49bb168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c49bb168"]])

export default __exports__